import { createContext, useContext, useMemo, useState, useCallback } from 'react';

// App-wide UI overlays so ANY view can open the shared Lead Drawer or the
// "Log a visit" modal. The drawer/modal are mounted once in App's shell.
const UIContext = createContext(undefined);

export function UIProvider({ children }) {
  const [leadId, setLeadId] = useState(null); // open Lead Drawer for this lead id
  const [visit, setVisit] = useState(null); // { leadId } | {} for Log Visit modal, null = closed

  const openLead = useCallback((id) => setLeadId(id), []);
  const closeLead = useCallback(() => setLeadId(null), []);
  const openLogVisit = useCallback((id = null) => setVisit({ leadId: id }), []);
  const closeLogVisit = useCallback(() => setVisit(null), []);

  const value = useMemo(
    () => ({ leadId, openLead, closeLead, visit, openLogVisit, closeLogVisit }),
    [leadId, visit, openLead, closeLead, openLogVisit, closeLogVisit],
  );
  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export function useUI() {
  const ctx = useContext(UIContext);
  if (ctx === undefined) throw new Error('useUI must be used within a UIProvider.');
  return ctx;
}
